module.exports = __webpack_public_path__ + "static/media/lingolink-3.cd9a93f7.jpg";